<template>
  <jc-dialog ref="createDialog" :show.sync="show"
             btn-confirm-text='<i class="fas fa-save"></i> Lưu'

             title="Xóa tính năng cho nhiều shop"
             type="red"
             @onConfirm="submit()"
  >
    <c-form ref="form">
      <c-select2 v-model="model.type" label="Tính năng" validate-rules="required">
        <option>-- Chọn tính năng --</option>
        <option v-for="item in listFeature" :value="item">{{ item }}</option>
      </c-select2>

      <c-input-tag v-model="model.shopCodes" label="Danh sách shop code" validate-rules="required"/>
    </c-form>
  </jc-dialog>
</template>

<script>
import dialogMixins from "@/mixins/dialogMixins";

export default {
  name: "add",
  mixins: [
    dialogMixins,
  ],
  props: {
    listFeature: Array
  },
  data: function () {
    return {
      model: {
        shopCodes: [],
        type: null,
      },
    }
  },
  methods: {
    resetForm() {
      this.model = {
        shopCodes: [],
        type: null,
      }
    },
    submit: function () {
      this.$refs.form.validate()
          .then(() => {
            this.$showLoader();
            this.$http
                .post("/moshop/api/fulfilment/config/shop/close-feature",
                    {
                      type: this.model.type,
                      shop_codes: this.model.shopCodes
                    }
                )
                .then(successRes => {
                  this.$stopLoader();

                  let data = successRes.data;
                  if (data.success) {
                    this.close();
                    this.$success();

                    this.$emit("success", successRes);
                  } else {
                    this.$error(data.message);
                    this.$emit("error", successRes);
                  }
                }, errorRes => {
                  this.$stopLoader();
                  this.errorNotify(errorRes);
                  this.$emit("error", errorRes);
                })
          })
    }
  }
}
</script>

<style scoped>

</style>